import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-auth-system',
  templateUrl: './auth-system.component.html',
  styleUrls: ['./auth-system.component.scss']
})
export class AuthSystemComponent implements OnInit {
  showonly=false;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  selectedTab: string = 'Login';  // Default tab selection
  successMsg: string = '';



  register(){
    this.showonly = !this.showonly;
  }






  
  constructor(private dialogRef: MatDialogRef<AuthSystemComponent>) { }

  ngOnInit(): void {
  }
  switchToLogin(msg?: string) {
    this.successMsg = msg || '';
    this.tabGroup.selectedIndex = 0;  // Switch to the "Login" tab
    if (this.successMsg) {
      setTimeout(() => this.successMsg = '', 16000);
    }
  }

  closeDialog() {
    this.dialogRef.close(); // This will close the open dialog.
  }

  onTabChange(event: any) {
    // Here we update the selectedTab based on the tab selected
    this.selectedTab = event.tab.textLabel;
}
}
